import { useEffect, useState } from 'react';

import axiosApiInstance from '@/api/shared/axios-instance';
import { LEAGUES } from '@/constants/leagues';
import { REDUCERS } from '@/constants/reducers';
import URL_FACTORY from '@/helpers/url-helper';

import JugadoresHeaderSection from '@/components/jugadores-v2/information/JugadoresHeaderSection';
import JugadoresConvocatoriaSeleccion from '@/components/jugadores-v2/JugadoresConvocatoriaSeleccion';
import MinutesActionsTabsPlayerComponent from './minutes-actions-tabs-player';
import MinutesActionsGeneralInfoPlayerComponent from './minutes-actions-general-info-player';
import MinutesActionsMatchesPlayerComponent from './minutes-actions-matches-player';
import MinutesActionsGraphicalPlayerComponent from './minutes-actions-graphical-player';
import MinutesActionsMatchesTotalPlayerComponent from './MinutesActionsMatchesTotalPlayerComponent';
import CustomDrawer from '@/DesignSystem/components/drawer/CustomDrawer';
import { currentSeasonStats } from '@/constants/site';
import PlacementModalComponent from '@/components/ads-components/placements/placementModal';

const MinutesActionsPlayerComponent = ({ playerId, dispatch }) => {
    const [open, setOpen] = useState(false);
    const [player, setPlayer] = useState(null);
    const [cache, setCache] = useState([]);
    const [anchor] = useState('right');
    const [selectedLeague, setSelectedLeague] = useState(LEAGUES.LA_LIGA);
    const [partidosSeleccionados, setPartidosSeleccionados] = useState([]);

    useEffect(() => {
        if (player?.partidos?.length > 0) {
            const partidosDelJugador =
                player?.partidos
                    ?.filter((x) => x.leagueId === selectedLeague || selectedLeague === 'all')
                    ?.sort((a, b) => new Date(b.date) - new Date(a.date)) ?? [];
            setPartidosSeleccionados(partidosDelJugador);
        }
    }, [selectedLeague, player]);

    const handleClose = () => {
        setOpen(false);
        dispatch({ type: REDUCERS.SHOW_PLAYER_MINUTES, payload: null });
    };

    useEffect(() => {
        if (playerId) {
            const isCached = cache?.find((x) => x.playerId == playerId && x.playerId > 0);

            if (isCached) {
                setOpen(true);
                setPlayer(isCached.data);
                return;
            }

            const url = URL_FACTORY.GetPlayerMinutes;

            const payload = {
                playerId: playerId,
                season: currentSeasonStats,
            };

            dispatch({ type: REDUCERS.SHOW_SPINNER });

            axiosApiInstance
                .post(url, payload)
                .then((response) => {
                    if (response?.data?.information || response.data?.if) {
                        setOpen(true);
                        setPlayer(response?.data);

                        // Add response to cache
                        setCache((prevCache) => [
                            ...prevCache,
                            {
                                playerId: response?.data.information?.id,
                                data: response?.data,
                            },
                        ]);
                    }
                })
                .finally(() => {
                    dispatch({ type: REDUCERS.HIDE_SPINNER });
                });
        } else {
            setOpen(false);
        }
    }, [playerId]);

    if (!player) {
        return null;
    }

    return (
        <CustomDrawer
            open={open}
            onClose={() => handleClose(anchor, false)}
            title={`Minutos disputados del jugador - ${currentSeasonStats}/${currentSeasonStats + 1}`}
        >
            <JugadoresHeaderSection player={player} />
            <JugadoresConvocatoriaSeleccion player={player} />
            <MinutesActionsTabsPlayerComponent
                partidos={player?.partidos ?? []}
                selectedLeague={selectedLeague}
                setSelectedLeague={setSelectedLeague}
            />
            <MinutesActionsGeneralInfoPlayerComponent partidos={partidosSeleccionados} totalJornadas={38} />
            <MinutesActionsMatchesPlayerComponent partidos={partidosSeleccionados} />

            <PlacementModalComponent />
            <MinutesActionsGraphicalPlayerComponent partidos={partidosSeleccionados} />
            <MinutesActionsMatchesTotalPlayerComponent partidos={partidosSeleccionados} isModal={true} />
        </CustomDrawer>
    );
};

export default MinutesActionsPlayerComponent;
